import { action } from 'mobx';

import type { BicData } from '../../model';

export const getCorAccountByBankName = action(
  (bicData: BicData[] | undefined, bankName: string): string | undefined =>
    bicData?.find((item) => item.name === bankName)?.corAccount
);
